export default "__VITE_ASSET__70dd9833__"